import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { SITE } from "@/lib/seoData";
import SocialLinks from "@/components/SocialLinks";
import OzyLogoMark from "@/components/OzyLogoMark";

/**
 * Shared header used on inner pages (suburb / category / blog / compliance).
 * Landing page keeps its own custom hero header.
 */
export default function SiteHeader() {
  return (
    <header className="sticky top-0 z-30 bg-[#050505]/85 backdrop-blur border-b border-zinc-900">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="font-bebas text-2xl tracking-[0.25em] text-white flex items-center gap-2.5" data-testid="site-header-logo">
          <OzyLogoMark className="w-9 h-9" data-testid="header-brand-mark" />
          <span>OZYLOANS<span className="text-[#E50914]">.</span></span>
        </Link>
        <nav className="hidden md:flex items-center gap-7 text-sm text-zinc-400">
          <Link to="/finance/commercial-property-loans" className="hover:text-white">Commercial</Link>
          <Link to="/finance/business-loans" className="hover:text-white">Business</Link>
          <Link to="/finance/smsf-property-loans" className="hover:text-white">SMSF</Link>
          <Link to="/finance/equipment-finance" className="hover:text-white">Asset & Equipment</Link>
          <Link to="/finance/refinance" className="hover:text-white">Refinance</Link>
          <Link to="/" className="hover:text-white">Australia-Wide</Link>
          <Link to="/insights" className="hover:text-white">Insights</Link>
        </nav>
        <div className="flex items-center gap-3">
          <SocialLinks size="sm" className="hidden sm:flex" />
          <a
            href={`tel:${SITE.phone}`}
            className="inline-flex items-center gap-2 text-white text-sm font-medium"
          >
            <Phone className="w-4 h-4 text-[#E50914]" /> {SITE.phoneDisplay}
          </a>
        </div>
      </div>
    </header>
  );
}
